import { ToolbeltSectionHeader } from '~/components/Toolbelt/components/ToolbeltSectionHeader'
import { useAppDispatch, useAppSelector } from '~/store/hooks'
import { setContinuousModeToggle, setOrthoModeToggle, setSnapToggle } from '~/store/tools'
import { Icon } from '~/ui/Icon'
import { ToggleButton } from '~/ui/ToggleButton'

export const CanvasSettings = () => {
  const { isContinuousModeEnabled, isOrthoModeEnabled, isSnapEnabled } = useAppSelector(state => state.tools)
  const dispatch = useAppDispatch()

  return (
    <>
      <ToolbeltSectionHeader title="Settings" icon={<Icon size="16" name="settingsGear" />} />
      <ToggleButton
        fullWidth
        variant="inset"
        isSelected={isOrthoModeEnabled}
        onChange={() => dispatch(setOrthoModeToggle())}
      >
        <Icon name="ortho" />
        Ortho
      </ToggleButton>
      <ToggleButton fullWidth variant="inset" isSelected={isSnapEnabled} onChange={() => dispatch(setSnapToggle())}>
        <Icon name="magnet" />
        Snap
      </ToggleButton>
      <ToggleButton
        fullWidth
        variant="inset"
        isSelected={isContinuousModeEnabled}
        onChange={() => dispatch(setContinuousModeToggle())}
      >
        <Icon name="multiSelect" />
        <span className="text-[10px]">Continuous</span>
      </ToggleButton>
    </>
  )
}
